import axios from 'axios'
import { getToken } from '@/utils/auth'
// import { serverUrl, clientId } from '../settings'
import { Message } from 'element-ui'
import store from '../store'
// import router from '../router'
export const baseurl = process.env.VUE_APP_API_BASE_URL

axios.defaults.withCredentials = false
// 创建axios实例
const service = axios.create({
  xsrfHeaderName: 'Authorization',
  baseURL: baseurl, // api的base_url
  timeout: 60000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  config => {
    if (getToken()) {
      // config.headers.Authorization = window.sessionStorage.getItem('token') // 让每个请求携带token--['Authorization']为自定义key 请根据实际情况自行修改
      // config.headers.clientId = process.env.NODE_ENV === 'production' ? process.env.VUE_APP_CLIENTID : clientId
      config.headers.Authorization = getToken() // 让每个请求携带自定义 token
    }
    config.headers.template = store.getters.isTemplate
    config.headers.mapId = store.getters.isTemplate ? store.getters.curMapId : undefined
    config.headers.cmsg = '5166f259fb07c67629ca49c76f86626c54a053055bece998ae0040e61bfb65c445142dfff1a2cd6b'
    return config
  },
  error => {
    alert(error)
    Promise.reject(error)
  }
)

// respone拦截器
service.interceptors.response.use(
  response => {
    // router.push({ name: 'Login' })
    if (response.data.code !== 200 && !response.config.responseType && response.data.code) {
      if (response.data.code === 401) {
        if (getToken()) {
          store.dispatch('clearToken')
        }
        // router.push({ name: 'Login' })
        window.location.href = '/login'
        Message.error(response.data.msg)
      } else if (response.data.code < 500) {
        Message.error(response.data.msg)
      } else {
        Message.error('请求失败，服务器正忙')
      }
    }
    return response.data
  },
  res => {
    console.log('err' + res) // for debug
    // router.push({ name: 'Login' })
    if (res.response.status === 401 || res.response.data.code === 401) {
      if (getToken()) {
        store.dispatch('clearToken')
      }
      window.location.href = '/login'
      Message.error(res.response.data.msg)
      return
    }
    if (res.response && res.response.status === 420) {
      // 代表分享地图时，已失效，此时不弹出错误窗口
    } else if (res.response && res.response.status === 4000) {
      // 代表 人员/地图/画布 数量已满时，此时不弹出错误窗口
    } else if (res.response.data.code !== 200) {
      if (res.response.data.code < 500) {
        Message.error(res.response.data.msg)
      } else {
        Message.error('请求失败，服务器正忙')
      }
    }
    // 格式化错误信息为通用异常处理
    if (res.response && res.response.data.msg) {
      res.message = res.response.data.msg
    }
    return Promise.reject(res)
  }
)

export default service
